import React, { useEffect, useMemo, useState } from "react";
import {useCaseManagement} from "./store";
import SalesTable from "./SalesTable";
import moment from "moment";

function SalesManagement() {
  const { salesReps, targets, salesLoading, fetchSalesRep, fetchTargets } = useCaseManagement();
  const [refresh, setRefresh]= useState(false);
  const startDate = moment().startOf("month").toISOString();
  const endDate = moment().endOf("month").toISOString();


  useEffect(() => {
    fetchSalesRep();
    fetchTargets(startDate, endDate);
  }, [refresh]);


  const data = useMemo(() => {
    if (!salesReps) return [];
    const _data = salesReps?.userRole?.map((rep) => {
      const target = targets?.find((target) => {
        return target?.hair_coach_id === rep?.user_id;
      });

      return {
        key: rep?.user_id,
        rep_name: rep?.user?.first_name,
        ...target,
      };
    });

    return _data?.sort((a, b) => {
      return a.hair_coach_id?.localeCompare(b.hair_coach_id);
    });
  }, [salesReps, targets]);


  return (
    <div>
        <SalesTable tableData={data} isLoading={salesLoading} refresh={refresh} setRefresh={setRefresh} />
    </div>
  );
}

export default SalesManagement;
